import React, { useState, useEffect } from 'react';
import { useClientNavigation } from '../hooks/useClientNavigation.mjs';
import axios from 'axios';
import Switch from 'react-switch';
import { styles } from '../styles/form.mjs';
import { apiUrl, apiUrlDadosGrupo } from '../api/client.mjs';

const FormularioDadosDoGrupo = () => {
    const [dadosDoGrupo, setDadosDoGrupo] = useState({
        id: '',
        nomeGrupo: '',
        mensagemPersonalizada: '',
        mensagemFinal: '',
        mensagemDeDez: '',
        boasVindasAtiva: false,
        msgHorarios: false,
        msgRec: false,
        msgVendas: false,
        mensagemBoasVindas: '',
        antispan: false,
        sorteativa: false
    });
    const { navigateToClient } = useClientNavigation();
    const clienteId = process.env.REACT_APP_CLIENT_ID;

    useEffect(() => {
        axios.get(apiUrl(`dados-do-grupo`))
            .then(response => {
                const data = response.data[0];
                if (data) {
                    setDadosDoGrupo({
                        id: data.id,
                        nomeGrupo: data.nome_grupo || '',
                        mensagemPersonalizada: data.mensagem_personalizada || '',
                        mensagemFinal: data.mensagem_final || '',
                        mensagemDeDez: data.mensagem_de_dez || '',
                        msgHorarios: data.msg_horarios === 'true' || data.msg_horarios === true,
                        msgRec: data.msg_rec === 'true' || data.msg_rec === true,
                        msgVendas: data.msg_vendas === 'true' || data.msg_vendas === true,
                        boasVindasAtiva: data.boasvindasativa === 'true' || data.boasvindasativa === true,
                        antispan: data.antispan === 'true' || data.antispan === true,
                        mensagemBoasVindas: data.mensagemboasvindas || '',
                        sorteativa: data.sorteativa === 'true' || data.sorteativa === true
                    });
                }
            })
            .catch(error => console.error('Erro ao buscar dados do grupo:', error));
    }, [clienteId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const updatedData = {
            id: dadosDoGrupo.id, // mantendo o ID
            cliente_id: clienteId, // mantendo o cliente_id
            mensagem_de_dez: dadosDoGrupo.mensagemDeDez,
            mensagem_final: dadosDoGrupo.mensagemFinal,
            mensagem_personalizada: dadosDoGrupo.mensagemPersonalizada,
            msg_horarios: dadosDoGrupo.msgHorarios,
            msg_rec: dadosDoGrupo.msgRec,
            msg_vendas: dadosDoGrupo.msgVendas,
            nome_grupo: dadosDoGrupo.nomeGrupo,
            mensagemboasvindas: dadosDoGrupo.mensagemBoasVindas,
            boasvindasativa: dadosDoGrupo.boasVindasAtiva,
            antispan: dadosDoGrupo.antispan,
            sorteativa: dadosDoGrupo.sorteativa
        };

        axios.put(apiUrlDadosGrupo(dadosDoGrupo.id), updatedData)
            .then(() => {
                navigateToClient('/grupo');
            })
            .catch(error => console.log("Operation failed: " + error.message));
    };

    return (
        <form onSubmit={handleSubmit} style={styles.form}>
            <label style={styles.label}>Nome do Grupo:</label>
            <input style={styles.input} type="text" value={dadosDoGrupo.nomeGrupo} onChange={(e) => setDadosDoGrupo({ ...dadosDoGrupo, nomeGrupo: e.target.value })} />
            <label style={styles.label}>Mensagem Personalizada:</label>
            <input style={styles.input} type="text" value={dadosDoGrupo.mensagemPersonalizada} onChange={(e) => setDadosDoGrupo({ ...dadosDoGrupo, mensagemPersonalizada: e.target.value })} />
            <label style={styles.label}>Mensagem de Rec | Plataformas ou Sorteios:</label>
            <textarea style={styles.textarea} value={dadosDoGrupo.mensagemDeDez} onChange={(e) => setDadosDoGrupo({ ...dadosDoGrupo, mensagemDeDez: e.target.value })} />
            <label style={styles.label}>Final de mensagem:</label>
            <input style={styles.input} type="text" value={dadosDoGrupo.mensagemFinal} onChange={(e) => setDadosDoGrupo({ ...dadosDoGrupo, mensagemFinal: e.target.value })} />
            <label style={styles.label}>Mensagem de Boas Vindas:</label>
            <textarea style={styles.textarea} value={dadosDoGrupo.mensagemBoasVindas} onChange={(e) => setDadosDoGrupo({ ...dadosDoGrupo, mensagemBoasVindas: e.target.value })} />

            <div style={{ backgroundColor: '#fafafc' }}>
                <h2 style={{ textAlign: 'center' }}>Ative ou desative as mensagens que você quer que o bot envie para seu grupo:</h2>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label>Ativar Mensagem de Horários:</label>
                    <Switch checked={dadosDoGrupo.msgHorarios} onChange={(checked) => setDadosDoGrupo({ ...dadosDoGrupo, msgHorarios: checked })} />
                    <label>Ativar Mensagem de Recomendações:</label>
                    <Switch checked={dadosDoGrupo.msgRec} onChange={(checked) => setDadosDoGrupo({ ...dadosDoGrupo, msgRec: checked })} />
                    <label>Ativar Mensagem de Vendas:</label>
                    <Switch checked={dadosDoGrupo.msgVendas} onChange={(checked) => setDadosDoGrupo({ ...dadosDoGrupo, msgVendas: checked })} />
                    <label>Ativar Mensagem de Boas Vindas:</label>
                    <Switch checked={dadosDoGrupo.boasVindasAtiva} onChange={(checked) => setDadosDoGrupo({ ...dadosDoGrupo, boasVindasAtiva: checked })} />
                    <label>Ativar AntiSpan no Grupo:</label>
                    <Switch checked={dadosDoGrupo.antispan} onChange={(checked) => setDadosDoGrupo({ ...dadosDoGrupo, antispan: checked })} />
                    <label>Ativar Mensagem de Sorte:</label>
                    <Switch checked={dadosDoGrupo.sorteativa} onChange={(checked) => setDadosDoGrupo({ ...dadosDoGrupo, sorteativa: checked })} />
                </div>
            </div>
            <button style={styles.button} type="submit">Salvar</button>
        </form>
    );
};

export default FormularioDadosDoGrupo;
